<template>
  <div class="homepage">
    <div class="top-bar">
      <h3 style="position: absolute; left: 4.8%">拍享券</h3>
      <div style="margin: 7px 6px 7px 0;">票券匣</div>
      <div class="icon ticket" >
        <a href="https://www.piapp.com.tw/app/download?type=ticket-holder">
          <img src="../../assets/img/ticket.svg"/>
        </a>
      </div>
    </div>
    <div>
      <AdsCarousel v-bind:banners="adBanner"/>
      <div v-if="mainenance.length > 0" class="maintenance-banners">
        <div class="banner" v-for="(m, index) in mainenance"
                            :key="'ab' + index">
          <a v-bind:href="m.ta_url" target="_blank">
            <img :src="m.ta_pic"/>
          </a>
        </div>
      </div>
      <div class="nav-icon-links--container" v-for="(brands, index) in brandBlock">
        <SectionTitle :title="brands.title" :more-link="'brandList'"  :brands="brandList"/>
        <IconLinkSlider/>
      </div>
      <div class="brand-recommend" v-for="(navIcon, index) in navIconBlock">
        <SectionTitle :title="navIcon.title" :hide-more="true"/>
        <div class="button-swiper">
          <NavIconLinks/>
        </div>
      </div>
      <ProductSlider/>
      <div v-if="entrance.length > 1" class="active-banners">
        <div class="banner" v-for="(e, index) in entrance"
             :key="'ab' + index">
          <a v-bind:href="e.ta_url" target="_blank">
            <img :src="e.ta_pic"/>
          </a>
        </div>
      </div>
      <ProductPointSlider/>
      <div class="curation-container" v-if="curationA.length > 0 && curationInfoA.length > 0">
        <CurationA/>
      </div>
      <div class="curation-container" v-if="curationB.length > 0 && curationInfoB.length > 0">
        <CurationB/>
      </div>
      <div v-if="testBanner.length > 0">
        <div class="test-link">
          <p>連結測試專區</p>
        </div>
        <AdsCarousel v-bind:banners="testBanner"/>
      </div>
    </div>
    <div class="foot">-已經到底囉-</div>
  </div>
</template>

<script>
import AdsCarousel from '../../components/homepage/AdsCarousel.vue'
import NavIconLinks from '../../components/homepage/NavIconLinks.vue'
import ProductSlider from '../../components/homepage/ProductSlider.vue'
import ProductPointSlider from '../../components/homepage/ProductPointSlider.vue'
import CurationA from '../../components/homepage/CurationA.vue'
import CurationB from '../../components/homepage/CurationB.vue'
import SectionTitle from '../../components/SectionTitle.vue'
import IconLinkSlider from '../../components/IconLinkSlider.vue'

export default {
  name: 'homepage',
  components: {
    AdsCarousel,
    NavIconLinks,
    ProductSlider,
    CurationA,
    CurationB,
    SectionTitle,
    IconLinkSlider,
    ProductPointSlider
  },
  created() {
    axios.all([getAd(), getBrand(), getProduct(), getCurationInfo()])
    .then(axios.spread((ad, brand, product, curationInfo) => {
      this.adBanner = ad.data.A;
      this.entrance = ad.data.B;
      this.mainenance = ad.data.C;
      this.brandList = brand.data;
      this.curationA = product.data.C;
      this.curationB = product.data.D;
      this.curationInfoA = curationInfo.data.A;
      this.curationInfoB = curationInfo.data.B;
      this.testBanner = ad.data.J;
    }))

    function getAd() {
      return axios.get('/ticket/api/ad/list')
    }

    function getBrand() {
      return axios.get('/ticket/api/brand/list')
    }

    function getProduct() {
      return axios.get('/ticket/api/product/list')
    }

    function getCurationInfo() {
      return axios.get('/ticket/api/curation/info/list')
    }
  },
  data: () => ({
    adBanner:[],
    entrance: [],
    mainenance: [],
    brandBlock: [{
      title: '推薦品牌',
    }],
    brandList: [],
    navIconBlock: [{
      title: '精選分類',
    }],
    curationA: [],
    curationInfoA: [],
    curationB: [],
    curationInfoB: [],
    testBanner: []
  }),
}
</script>

<style lang="scss" scoped>
body {
  margin: 0px;
}

.top-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  top: 0;
  background-color: #fff;
  height: 48px;
  width: 100%;
  padding: 30px 4.8%;
  z-index: 10;

  .icon {
    width: 28px;
    height: 28px;
    border-radius: 14px;
    border: solid 1px #d9dbde;

    img {
      width: 100%;
    }
  }
}

.homepage {
  padding-top: 60px;

  .nav-icon-links--container {
    //padding: 20px 4.8% 0 4.8%;
    border-bottom: 10px solid #f3f5f8;
    padding: 25px 4.8%;
    position: relative;
    z-index: 0;
  }

  .curation-container {
    background-color: #f3f5f8;
  }

  .active-banners {
    padding: 30px 4.8% 0 4.8%;
    display: flex;
    justify-content: space-between;

    .banner {
      font-size: 0;
      width: 48.7%;
      border-radius: 14px;
      overflow: hidden;

      img {
        width: 100%;

        &.error-img {
          & + .error-holder {
            display: block;
          }
        }
      }

      .error-holder {
        display: none;
      }
    }
  }

  .maintenance-banners {
    padding: 20px 4.8%;
    display: flex;
    justify-content: space-between;

    .banner {
      font-size: 0;
      width: 100%;
      border-radius: 7.8px;
      overflow: hidden;

      img {
        width: 100%;

        &.error-img {
          & + .error-holder {
            display: block;
          }
        }
      }

      .error-holder {
        display: none;
      }
    }
  }

  .brand-recommend {
    border-bottom: 10px solid #f3f5f8;
    padding: 23px 4.8%;
    position: relative;
    z-index: 0;

    .swiper-container {
      overflow: hidden;
      font-size: 0;
      min-height: 150px;
    }
  }

  .chosen-product-container {
    padding: 0 18px 24px 18px;
  }

  .foot {
    color: #767676;
    font-size: 18px;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #f3f5f8;
  }
  .test-link{
    margin-left:4.5%;
    margin-top:25px;
    p {
      font-size: 18px;
      font-weight: bold;
      color: #1da7fc;
    }
  }
}
</style>
